import {createFeatureSelector, createSelector} from '@ngrx/store';
import {FxRateState} from '../reducers/fx-rate.reducer';
export const getFxRateState = createFeatureSelector<FxRateState>(
  'fx-rates'
);

export const getCountriesTreeData = function(reportId: string, currencyType: string){
  return createSelector(
    getFxRateState,
    (state: FxRateState) => state.countryTreeData[reportId+currencyType]
  );
};
export const getCurrenciesTreeData = function(reportId: string, currencyType: string){
  return createSelector(
    getFxRateState,
    (state: FxRateState) => state.currencyTreeData[reportId+currencyType]
  );
};
export const getReport = function(reportId: string){
  return createSelector(
    getFxRateState,
    (state: FxRateState) => state.reports[reportId]
  );
};

